import React from "react";
import "../css/footer.css";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <>
      <footer>
        <div class="row">
          <div class="footer-col">
            <div className="footer-col-logo">
              {/* <img src={Logo} alt="" /> */}
              <h2>MP Holidays Pvt Ltd.</h2>
            </div>
            {/* <p>Your trusted partner in wellness, offering comprehensive medical resources and services.</p> */}
            <div className="contact-col">
              <p>
                <i class="fa-solid fa-location-dot"></i>
                <p>
                  G10, near Nawada Metro Station, Shyam Park, Nawada Majra Village, Nawada, New Delhi, Delhi, 110059
                </p>
              </p>
            </div>
            <div className="contact-col">
              
             
              <p>
                <i class="fa-solid fa-phone-volume"></i>
                <a
                  href="tel:+91 8745000242"
                  target="_blank"
                  aria-label="call us for hotel booking"
                >
                +91 8745000242
                </a>
              </p>
               <p>
                <i class="fa-solid fa-phone-volume"></i>
                <a
                  href="tel:+91 99718 34101"
                  target="_blank"
                  aria-label="call us for hotel booking"
                >
                +91 99718 34101
                </a>
              </p>
              <p>
                <i class="fa-solid fa-envelope"></i>
                <a
                  href="mailto:welcome@mpholidays.online"
                  target="_blank"
                  aria-label="mail us for hotel booking"
                >
                  welcome@mpholidays.online
                </a>
              </p>
            </div>
            <div className="contact-col">
              <p>
                <i class="fa-regular fa-clock"></i>
                <p>Mon – Sat: 10:00 am – 06:00 pm</p>
              </p>
            </div>
          </div>
          <div class="footer-col">
            <h4>menu</h4>
            <span
              onClick={() => {
                navigate("/");
              }}
            >
              Home
            </span>
            <span
              onClick={() => {
                navigate("/about");
              }}
            >
              About
            </span>
            <span
              onClick={() => {
                navigate("/packages");
              }}
            >
              Packages
            </span>
            <span
              onClick={() => {
                navigate("/destinations");
              }}
            >
              Destinations
            </span>
            <span
              onClick={() => {
                navigate("/vehicle");
              }}
            >
              Vehicle
            </span>
            <span
              onClick={() => {
                navigate("/payment");
              }}
            >
              Payment
            </span>
          </div>
          <div class="footer-col">
            <h4>get help</h4>
            <span
              onClick={() => {
                navigate("#");
              }}
            >
              FAQ
            </span>
            <span
              onClick={() => {
                navigate("/contact");
              }}
            >
              Contact
            </span>
            <span
              onClick={() => {
                navigate("/privacy-policy");
              }}
            >
              Privacy Policy
            </span>
            <span
              onClick={() => {
                navigate("/payment");
              }}
            >
              {/* Payment Options */}
            </span>
            <span
              onClick={() => {
                navigate("/cancellation-policy");
              }}
            >
              Cancellation & Refund Policy
            </span>
          </div>
          <div class="footer-col">
            <h4>Services</h4>
            <span>Hotels</span>
            <span>Resorts</span>
            <span>Tour Packages</span>
            <span>Wildlife Tour</span>
            <span>Transport</span>
          </div>
          <div class="footer-col">
            <h4>Connect With Us</h4>
            <div class="social-links">
              <a
                href="#"
                target="_blank"
                aria-label="follow us on instagram"
              >
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a
                href="https://www.facebook.com/MPHOLIDAYSPVTLTD"
                target="_blank"
                aria-label="follow us on facebook"
              >
                <i class="fa-brands fa-facebook"></i>
              </a>
              <a
                href="#"
                target="_blank"
                aria-label="follow us on twitter"
              >
                <i class="fa-brands fa-twitter"></i>
              </a>
            </div>
            {/* <div className="news-letter">
              <input type="text" placeholder="Enter your E-Mail" />
              <button>Subscribe</button>
            </div> */}
          </div>
        </div>

        <div className="footer-copyright">
          <div className="footer-copyright-left">
            <p>Copyright © 2022-2025.</p>
          </div>

          <div className="footer-copyright-right">
            <p>
              All Rights Reserved. -{" "}
              <a
                href="https://www.mpholidays.online/"
                target="_blank"
                rel="noopener noreferrer"
              >
                MP Holidays Pvt Ltd.
              </a>
            </p>
          </div>
        </div>

      </footer>
    </>
  );
};

export default Footer;
